import styled from 'styled-components'
import { ApproveSquirrel } from 'Icons'

const Wrap = styled.div`
  border: 1px solid #66b913;
  color: #66b913;
  background: #f0f8e7;
  padding: 14px 0 14px;
  text-align: center;
  border-radius: 5px;
  font-weight: 700;
  height: 45px;
  position: relative;
  overflow: hidden;
  white-space: nowrap;

  @media (max-width: 1280px) {
    white-space: nowrap;

    > div > span {
      margin-left: 10px;
    }
  }

  > div {
    position: absolute;
    left: 50%;
    transform: translate(-50%, -50%);
    padding-bottom: 11px;
    width: 100%;

    > span {
      top: 4px;
      position: relative;
      font-size: 14px;
    }

    svg {
      width: 50px;
      display: inline-block;
      position: relative;
      top: 20px;
      left: -5px;
    }
  }
`

const NoPostToApprove: React.FC = () => {
  return (
    <Wrap>
      <div>
        <span>No posts awaiting approval.</span>
        <ApproveSquirrel />
      </div>
    </Wrap>
  )
}

export default NoPostToApprove
